import { AppRoutes } from '@reza-ais-fe/reza-ais-fe-utils';
import { MenuItem } from '@openng/optimus-ui/api';

export const navigationItems: MenuItem[] = [
  {
    label: 'Správa oprávnění',
    routerLink: AppRoutes.Opravneni,
  },
  {
    label: 'Ověření oprávnění',
    id: AppRoutes.OvereniOpravneni,
    items: [
      {
        label: 'Ověření pro zastupující osobu',
        id: AppRoutes.OvereniOpravneni_Zastupujici,
        routerLink: AppRoutes.OvereniOpravneni + '/' + AppRoutes.OvereniOpravneni_Zastupujici,
      },
      {
        label: 'Ověření pro zastupovanou osobu',
        id: AppRoutes.OvereniOpravneni_Zastupovany,
        routerLink: AppRoutes.OvereniOpravneni + '/' + AppRoutes.OvereniOpravneni_Zastupovany,
      },
      {
        label: 'Ověření dle kódu oprávnění k zastupování',
        id: AppRoutes.OvereniOpravneni_KodOkz,
        routerLink: AppRoutes.OvereniOpravneni + '/' + AppRoutes.OvereniOpravneni_KodOkz,
      },
    ],
  },
  {
    label: 'Šablony',
    id: AppRoutes.Sablony,
    items: [
      {
        label: 'Správa šablon',
        id: AppRoutes.Sablony,
        routerLink: AppRoutes.Sablony,
      },
      {
        label: 'Správa skupin šablon',
        id: AppRoutes.Sablony_Skupiny,
        routerLink: AppRoutes.Sablony_Skupiny,
      },
    ],
  },
  {
    label: 'Reklamace',
    id: AppRoutes.Reklamace,
    items: [
      {
        label: 'Správa reklamací',
        id: AppRoutes.Reklamace,
        routerLink: AppRoutes.Reklamace,
      },
      {
        label: 'Reklamace implicitních oprávnění',
        id: AppRoutes.Reklamace_ImplicitnichOpravneni,
        routerLink: AppRoutes.Reklamace_ImplicitnichOpravneni,
      },
      {
        label: 'Kontrola reklamací implicitních oprávnění',
        id: AppRoutes.Reklamace_KontrolaReklamaciImplicitnichOpravneni,
        routerLink: AppRoutes.Reklamace_KontrolaReklamaciImplicitnichOpravneni,
      },
    ],
  },
  {
    label: 'Správa certifikátů',
    routerLink: AppRoutes.Certifikaty,
  },
  {
    label: 'Ověření certifikátu',
    routerLink: AppRoutes.CertifikatyOvereni,
  },
  {
    label: 'Číselníky',
    id: AppRoutes.Ciselniky,
    items: [
      {
        label: 'Číselník objektů omezení',
        id: AppRoutes.ObjektyOmezeni,
        routerLink: AppRoutes.Ciselniky + '/' + AppRoutes.ObjektyOmezeni,
      },
      {
        label: 'Číselník rolí',
        id: AppRoutes.Role,
        routerLink: AppRoutes.Ciselniky + '/' + AppRoutes.Role,
      },
      {
        label: 'Číselník specifických omezení',
        id: AppRoutes.SpecifickaOmezeni,
        routerLink: AppRoutes.Ciselniky + '/' + AppRoutes.SpecifickaOmezeni,
      },
    ],
  },
  // Dokumentace je odkaz v záhlaví (header.component.html) – navigace se tak vejde na jeden řádek
  {
    label: 'Statistiky',
    id: AppRoutes.Statistiky,
    // routerLink: AppRoutes.Statistiky,
    items: [
      {
        label: 'Počet oprávnění k zastupování',
        id: AppRoutes.Statistiky_PocetOpravneniKZastupovani,
        routerLink: AppRoutes.Statistiky + '/' + AppRoutes.Statistiky_PocetOpravneniKZastupovani,
      },
      {
        label: 'Změny oprávnění k zastupování',
        id: AppRoutes.Statistiky_ZmenyOpravneniKZastupovani,
        routerLink: AppRoutes.Statistiky + '/' + AppRoutes.Statistiky_ZmenyOpravneniKZastupovani,
      },
      {
        label: 'Vytvořená oprávnění k zastupování dle šablon',
        id: AppRoutes.Statistiky_OpravneniKZastupovaniDleSablon,
        routerLink: AppRoutes.Statistiky + '/' + AppRoutes.Statistiky_OpravneniKZastupovaniDleSablon,
      },
      {
        label: 'Počtu certifikátů',
        id: AppRoutes.Statistiky_PoctuCertifikatu,
        routerLink: AppRoutes.Statistiky + '/' + AppRoutes.Statistiky_PoctuCertifikatu,
      },
    ],
  },
  {
    label: 'Archiv',
    id: AppRoutes.Archiv,
    // routerLink: AppRoutes.Archiv,
    items: [
      {
        label: 'Oprávnění k zastupování',
        id: AppRoutes.Opravneni,
        routerLink: AppRoutes.Archiv + '/' + AppRoutes.Opravneni,
      },
      {
        label: 'Šablony',
        id: AppRoutes.Sablony,
        routerLink: AppRoutes.Archiv + '/' + AppRoutes.Sablony,
      },
      {
        label: 'Certifikáty',
        id: AppRoutes.Certifikaty,
        routerLink: AppRoutes.Archiv + '/' + AppRoutes.Certifikaty,
      },
    ],
  },
];
